import $ from 'jquery';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery.js';

export default class USPBannerBar {
    init()
    {
        let me = this;

        $(document).ready(() => {
            me.transition();
            $(window).on('changed.zf.mediaquery', function () {
                me.transition();
            });
        });
    }

    transition()
    {
        if (!this.module && ! MediaQuery.atLeast('large')) {
            import('./transition').then((Transition) => {
                this.module = new Transition.default('#uspBannerBar .cell.usp');
                this.module.init();
            });
        }
    }
}